import { getDocument } from 'pdfjs-dist';
import { parseGIF, decompressFrames } from 'gifuct-js'
import { maxFilesPerNetwork } from './constante'
import FastAverageColor from 'fast-average-color';

const fac = new FastAverageColor();

//getFilesByNetwork(medias = this.formData.files, networks = this.listNetworkSort, formDataNetwork = this.formData.formDataNetwork, files = this.files, isUploadRequired = false)
export const getFilesByNetwork = (medias, networks, formDataNetwork, files, isUploadRequired = false) => {
    console.log("getFilesByNetwork",{files,medias})
    let filesPerNetwork = {}
    networks.forEach(networkName => {
        filesPerNetwork[networkName] = medias.reduce((filesAccumulator,media) => {
            //echec de de l'upload
            if (!files[media.id] || (!files[media.id].isUpload && (isUploadRequired || !files[media.id].uploadProgress))) return filesAccumulator
            const file = files[media.id];

            if (file.errorNetwork.hasOwnProperty(networkName)) return filesAccumulator
          
            switch (networkName) {
                case 'facebook':
                    if (formDataNetwork.facebook.typeMedia == 'video' && file.info.type2 !== 'video') return filesAccumulator
                    if (formDataNetwork.facebook.typeMedia == 'image' && (file.info.type2 !== 'image' || file.info.type == 'image/gif')) return filesAccumulator
                    break;
                case 'instagram':
                    if (!['video', 'image'].includes(file.info.type2) || file.info.type == 'image/gif') return filesAccumulator
                    break;
                case 'linkedin':
                    if (formDataNetwork.linkedin.survey && formDataNetwork.linkedin.survey.active) return filesAccumulator
                    if (formDataNetwork.linkedin.typeMedia == 'video' && (file.info.type2 !== 'video' || filesAccumulator.some(f => f.info.type2 == 'video'))) return filesAccumulator
                    if (file.info.type2 !== formDataNetwork.linkedin.typeMedia) return filesAccumulator
                    break;
                case 'threads':
                    if (!['video', 'image'].includes(file.info.type2) || file.info.type == 'image/gif') return filesAccumulator
                    break;
                case 'twitter':
                    if (formDataNetwork.twitter.typeContent == 'video' && (file.info.type2 !== 'video' || filesAccumulator.some(f => f.info.type2 == 'video'))) return filesAccumulator
                    if (file.info.type2 !== formDataNetwork.twitter.typeContent) return filesAccumulator
                    break;
                case 'tiktok':
                    if (file.info.type2 !== 'video' || filesAccumulator.some(f => f.info.type2 == 'video')) return filesAccumulator
                    break;
                case 'google':
                    if (file.info.type2 !== 'image' || file.info.type == 'image/gif' || filesAccumulator.some(f => f.info.type2 == 'image')) return filesAccumulator
                    break
                case 'telegram':
                    return filesAccumulator
                case 'pinterest':
                    if (!['video', 'image'].includes(file.info.type2) || file.info.type == 'image/gif' || filesAccumulator.some(f => ['video', 'image'].includes(f.info.type2))) return filesAccumulator
                    break;
                case 'youtube':
                    if (file.info.type2 !== 'video' || filesAccumulator.some(f => f.info.type2 == 'video')) return filesAccumulator
                    break;
                
                default:

                    break;
            }

            return [...filesAccumulator, {...file,...file.info}]
        },[]).slice(0,maxFilesPerNetwork[networkName])
    })
    return filesPerNetwork
}

export const getInfoFile = async (file, url) => {
    const infoFile = {
        name:undefined,
        size:undefined,
        type:undefined,
        type2:undefined,
        width: undefined,
        height: undefined,
        aspectRatio: undefined,
        framesLength: undefined,
        averageColor: undefined,
        enclosure:{
            pdf:undefined
        }
    }

    infoFile.name = file.name
    infoFile.size = file.size
    infoFile.type = file.type

    infoFile.type2 = ['image','video'].includes(file.type.split('/')[0]) ? 
            file.type.split('/')[0]
        : ['pdf'].includes(file.type.split('/')[1]) ?
            file.type.split('/')[1]
        : undefined;
    
    // get dimensions & averageColor
    if (infoFile.type && url) { 
        

        if (infoFile.type.startsWith('image/')) {
            let img = new Image();
            await new Promise((resolve) => {
                img.onload = async (e) => {
                    infoFile.width= img.width,
                    infoFile.height= img.height,
                    infoFile.aspectRatio= img.width / img.height
         
                    let facColor = await fac.getColorAsync(e.target);
                    if (facColor.hex) infoFile.averageColor = facColor.hex
                    resolve();
                };
                img.onerror = () => {
                    resolve();
                };
                img.src = url;
            });
        }

        if (infoFile.type == 'image/gif') {
            let buffer = await fileToArrayBuffer(file);
            let gif = parseGIF(buffer);
            let frames = decompressFrames(gif, false);
            infoFile.framesLength= frames.length
        }

        if (infoFile.type.startsWith('video/')) {
            let video = document.createElement('video');
            await new Promise((resolve) => {
                video.onloadedmetadata = async (e) => {
                    infoFile.width= video.videoWidth, 
                    infoFile.height= video.videoHeight,
                    infoFile.aspectRatio= video.videoWidth / video.videoHeight      
                    console.log("onloadedmetadata",e.target)  
                
                    e.target.muted = true;
                    await e.target.play();
                    let c = document.createElement('canvas')
                    c.height = e.target.videoHeight || parseInt(e.target.style.height)
                    c.width = e.target.videoWidth || parseInt(e.target.style.width)
                    const ctx = c.getContext('2d')
                    ctx.drawImage(e.target, 0, 0)
                    let facColor = await fac.getColorAsync(c.toDataURL());
                    if (facColor.hex) infoFile.averageColor = facColor.hex
          
                    resolve();
                };

                video.onerror = () => {
                    resolve();
                };
                video.src = url;
            });
            video.src = '';
        }
    }

    //enclosure
    if (infoFile.type === 'application/pdf') {
        try {
            let doc = await getDocument(url).promise;
            let page = await doc.getPage(1);
            infoFile.enclosure.pdf = (await makeThumb(page)).toDataURL();
        } catch (error) {
            console.error(error);
        }
    }

    return infoFile
}

export const getErrorNetworkFile = (fileInfo) => {
    const sizeInMo = fileInfo.size / (1024 * 1024)

    const maxSizePerNetwork = {facebook:4,twitter:5,instagram:8, google: 5}
    const maxDimensionPerNetwork = {twitter:'8192x8192',linkedin: 36152320, instagram:'1.91:1'}
    const minDimensionPerNetwork = {twitter:'4x4',google: '250x250', instagram:'4:5'}
    const maxFrameGif= {twitter: 350,linkedin: 250}

    const errorNetwork = {}

    const addErrorFile = (network, property, textError) => {
        errorNetwork[network] = {
            ...(errorNetwork[network] || {}),
            [property] : textError
        }
    }
    
    Object.entries(maxSizePerNetwork).forEach(([network, maxSize]) => {
        if (sizeInMo >= maxSize) {
            addErrorFile(network, 'size', `La taille maximum est de ${maxSize}Mo`)
        }
    });

    //Dimension max
    Object.entries(maxDimensionPerNetwork).forEach(([network, dimension]) => {
        if (Number.isInteger(dimension)) {
            if (fileInfo.width * fileInfo.height > dimension) {
                addErrorFile(network,'size', `Le media est trop grand et dépasse les dimensions autorisées.`)
            }

        }else if(dimension.includes('x')){
            const [maxWidth,maxHeight] = dimension.split('x')
            if (fileInfo.width > maxWidth || fileInfo.height > maxHeight) {
                addErrorFile(network,'size', `Les dimensions du media ne doivent pas dépasser ${maxWidth} pixels de largeur et ${maxHeight} pixels de hauteur.`)
            }
        }else if (dimension.includes(':')) {
            console.error("Fonctionnalité en cours de développement")
        }
    });

    //Dimension min
    Object.entries(minDimensionPerNetwork).forEach(([network, dimension]) => {
        if(Number.isInteger(dimension)){
            if (fileInfo.width * fileInfo.height < dimension) {
                addErrorFile(network,'size', `Le media est trop petit et n'atteint pas les dimensions autorisées.`)
            }
        }else if (dimension.includes('x')) {
            const [minWidth,minHeight] = dimension.split('x')
            if (fileInfo.width < minWidth || fileInfo.height < minHeight) {
                addErrorFile(network,'size', `Les dimensions du media doivent dépasser ${minWidth} pixels de largeur et ${minHeight} pixels de hauteur.`)
            }
        }else if (dimension.includes(':')) {
            console.error("Fonctionnalité en cours de développement")
        }
    });

    //max frame gif
    Object.entries(maxFrameGif).forEach(([network, maxFrame]) => {
        if(Number.isInteger(maxFrame) && fileInfo.framesLength){
            if (fileInfo.framesLength > maxFrame) {
                addErrorFile(network,'frame', `Le GIF dépasse le nombre maximum de frames autorisées.`)
            }
        }
    });

    return errorNetwork

}

export const findDifferences = (defaultObj, modifiedObj) => {
    let differences = {};

    // try {
    //     if (Object.keys(defaultObj).length !== Object.keys(modifiedObj).length) return modifiedObj
    //     if (Object.keys(defaultObj).join('') !== Object.keys(modifiedObj).join('')) return modifiedObj
    // } catch (error) {
    //     return modifiedObj
    // }

    if (typeof modifiedObj !== 'object' && modifiedObj !== null) return modifiedObj
    
    const allKeys = [...(new Set(Object.keys(defaultObj).concat(Object.keys(modifiedObj))))] 
    
    // Parcourir les propriétés de l'objet par défaut
    for (let key of allKeys) {
        if (!modifiedObj.hasOwnProperty(key)) {
            differences[key] = 'deleted_value'   
        }else if (!defaultObj.hasOwnProperty(key)) {
            differences[key] = modifiedObj[key]
        }else{
            if (typeof defaultObj[key] === 'object' && defaultObj[key] !== null) {
                if (Array.isArray(defaultObj[key]) || key == 'stickers') {
                    // Comparer les tableaux
                    if (JSON.stringify(defaultObj[key]) !== JSON.stringify(modifiedObj[key])) {
                        differences[key] = modifiedObj[key];
                    }
                } else if (defaultObj[key] instanceof Set) {
                    // Comparer les Set
                    if (JSON.stringify([...defaultObj[key]]) !== JSON.stringify([...modifiedObj[key]])) {
                        differences[key] = modifiedObj[key];
                    }
                } else {
                    // Comparer les objets (récursion)
                    const objDiff = findDifferences(defaultObj[key], modifiedObj[key]);

                    if (typeof objDiff !== 'object' || Object.keys(objDiff).length > 0) {
                        differences[key] = objDiff;
                    }
                }
            } else {
                // Comparer les valeurs primitives
                if (defaultObj[key] !== modifiedObj[key]) {
                    differences[key] = modifiedObj[key];
                }
            }
        }
    }
    return differences;
}

export const mergeUpdates = (defaultObj, updateObj) => {
    for (let key in updateObj) {
        if (updateObj.hasOwnProperty(key)) {
            // Si la valeur est un objet, on doit faire une fusion récursive
            if (updateObj[key] === 'deleted_value'){
                delete defaultObj[key]
            }else if (typeof updateObj[key] === 'object' && updateObj[key] !== null && !Array.isArray(updateObj[key]) && key !== 'stickers') {
                // Si l'objet par défaut n'a pas cette clé, on initialise un objet vide
                if (!defaultObj[key]) {
                    defaultObj[key] = {};
                }
                // Fusion récursive
                mergeUpdates(defaultObj[key], updateObj[key]);
            } else {
                // Sinon, on remplace directement la valeur
                defaultObj[key] = updateObj[key];
            }
        }
    }
}

export const deepClone = (obj) => {
    // Vérifier si c'est un objet ou un tableau
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }

    // Gérer les dates
    if (obj instanceof Date) {
        return new Date(obj);
    }

    // Gérer les tableaux
    if (Array.isArray(obj)) {
        return obj.map(item => deepClone(item));
    }

    // Gérer les objets Set
    if (obj instanceof Set) {
        return new Set([...obj].map(item => deepClone(item)));
    }

    // Gérer les objets Map
    if (obj instanceof Map) {
        return new Map(Array.from(obj.entries()).map(([key, value]) => [deepClone(key), deepClone(value)]));
    }

    // Gérer les autres objets (Object)
    const copy = {};
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            copy[key] = deepClone(obj[key]);
        }
    }
    
    return copy;
}

export const unescapeSpecialChars = (str) => {
    // Remplacer les séquences échappées par leurs équivalents littéraux
    return str
        .replace(/\\n/g, '\n')          // Newline '\n'
        .replace(/\\t/g, '\t')          // Tab '\t'
        .replace(/\\r/g, '\r')          // Carriage return '\r'
        .replace(/\\f/g, '\f')          // Form feed '\f'
        .replace(/\\v/g, '\v')          // Vertical tab '\v'
        .replace(/&nbsp;/g, ' ')        // '&nbsp;' -> space ' '
        .replace(/\\\\/g, '\\');        // Backslash '\\'
}

export const getVideoDuration = (url) => {
    return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        video.src = url;

        video.addEventListener('loadedmetadata', function() {
            resolve(video.duration);  // Renvoie la durée en secondes
        });

        video.addEventListener('error', function() {
            reject('Impossible de charger la vidéo/musique.');
        });
    });
}


const makeThumb = async (page) => {
    // draw page to fit into 96x96 canvas
    var vp = page.getViewport({ scale: 1, });
    var canvas = document.createElement("canvas");
    var scalesize = 1;
    canvas.width = vp.width * scalesize;
    canvas.height = vp.height * scalesize;
    var scale = Math.min(canvas.width / vp.width, canvas.height / vp.height);

    return page.render({ canvasContext: canvas.getContext("2d"), viewport: page.getViewport({ scale: scale }) }).promise.then(function () {
        return canvas; 
    });
}

const fileToArrayBuffer = async (file) => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = function(e) {
            let arrayBuffer = new Uint8Array(reader.result);
            resolve(arrayBuffer)
        }

        reader.readAsArrayBuffer(file);
    });
}

export const postNetworkValidator = (networks, filesByNetwork, formDataNetwork, text) => {
    const validator = {}

    networks.forEach(networkName => {
        validator[networkName] = {
            isValid : true,
            showRender : true,
            error : []
        }

        switch (networkName) {
            case 'facebook':
            
                if (
                    !filesByNetwork[networkName].length &&
                    text.length == 0 &&
                    !formDataNetwork[networkName].snippet.link
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins un média, un contenu ou un lien."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;

            case 'instagram':
                if (!filesByNetwork[networkName].length) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins une image ou une video."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;

            case 'linkedin':
                if (
                    !filesByNetwork[networkName].length &&
                    text.length == 0 &&
                    !formDataNetwork[networkName].snippet.link &&
                    !formDataNetwork[networkName].survey.active
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins un média, un contenu, un lien ou un sondage."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;
            case 'threads':
                
                if (
                    !filesByNetwork[networkName].length &&
                    text.length == 0 &&
                    !formDataNetwork[networkName].snippet.link
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins un média, un contenu ou un lien."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;
            case 'twitter':
                if (
                    !filesByNetwork[networkName].length &&
                    text.length == 0 &&
                    !formDataNetwork[networkName].snippet.link
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins un média, un contenu ou un lien."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;
            case 'tiktok':
                if (
                    !filesByNetwork[networkName].length
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter une video."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;
            case 'google':
                if (
                    !filesByNetwork[networkName].length &&
                    !formDataNetwork[networkName].snippet.link
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins une image ou un lien."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;
            case 'telegram':
                if (
                    text.length == 0
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter un contenu."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;

            case 'pinterest':
                if (
                    !filesByNetwork[networkName].length &&
                    !formDataNetwork[networkName].snippet.link
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins une image, une viédo ou un lien."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;

            case 'youtube':
                if (
                    !filesByNetwork[networkName].length
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter une video."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;
            default:
                break;
        }
    });
    
    return validator
}